import { api } from "@/api/client";
import type { AuthMode } from "@/types/api";

/** Справочник баз 1С для SSO-режима. В SSO-сессии портал ходит в 1С по JWT в
 *  базу подключения пользователя, а подключение ссылается на базу справочника
 *  (адрес публикации + `aud` токена). Заводит админ, общий для всех. */
export interface OneCBase {
  id: string;
  name: string;
  /** Адрес публикации без `/odata/…` и `/hs/…`. */
  base_url: string;
  /** `aud` токена — ровно как в `default.vrd` публикации. */
  audience: string;
  config_type: string;
  /** Ключ metadata учётки SSO с именем пользователя 1С (`onec_unf`). */
  metadata_key: string;
  created_at: string;
  updated_at: string;
}

/** Справочник + состояние ТЕКУЩЕЙ сессии. */
export interface OneCBaseList {
  bases: OneCBase[];
  auth_mode: AuthMode;
  /** Есть ли у SSO-сессии пользователь 1С (`onec_unf`). Для не-SSO — false. */
  has_onec_unf: boolean;
}

export interface OneCBaseCreate {
  name: string;
  base_url: string;
  audience: string;
  metadata_key: string;
}

export interface OneCBaseUpdate {
  name?: string;
  base_url?: string;
  audience?: string;
  metadata_key?: string;
}

/** Конфигурации 1С справочника: бэкенд пока принимает только УНФ. */
export const CONFIG_TYPE_TITLES: Record<string, string> = { unf: "УНФ" };

/** Ключ metadata пользователя 1С УНФ в учётке SSO — единственный, что знает бэкенд. */
export const DEFAULT_METADATA_KEY = "onec_unf";

export const ONEC_BASES_QUERY_KEY = ["onec-bases"] as const;

export async function listOneCBases(): Promise<OneCBaseList> {
  const { data } = await api.get<OneCBaseList>("/onec-bases");
  return data;
}

export async function createOneCBase(body: OneCBaseCreate): Promise<OneCBase> {
  const { data } = await api.post<OneCBase>("/onec-bases", body);
  return data;
}

export async function updateOneCBase(id: string, body: OneCBaseUpdate): Promise<OneCBase> {
  const { data } = await api.put<OneCBase>(`/onec-bases/${id}`, body);
  return data;
}

export async function deleteOneCBase(id: string): Promise<void> {
  await api.delete(`/onec-bases/${id}`);
}
